module.exports = __webpack_public_path__ + "img/about_a05.fd09026a.svg";